import axios from 'axios';
import OnboardingIndex from '../OnboardingIndex.vue';
import { LOGIN_URL } from '@/utils/system_constants/constant.js';
import alert_mixin from '@/utils/mixins/alert_mixin';

export default {
  name: 'UserLogin',
  components: {
    OnboardingIndex
  },
  mixins: [alert_mixin],
  data() {
    return {
      title: 'Welcome Back',
      submitButtonText: 'Sign In',
      url_forgot_password: '/forgot_password',
      verification_running: false,
      username: '',
      password: '',
      show_password: false
    };
  },
  methods: {
    async login_function() {
      const username = String(this.username || '').trim();
      const password = String(this.password || '');

      if (!username || !password) {
        this.show_error('Username and password are required.');
        return;
      }

      this.verification_running = true;

      try {
        const response = await axios.post(LOGIN_URL, {
          username,
          password
        });

        const response_data =
          typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

        sessionStorage.setItem('token', response_data.token);
        sessionStorage.setItem('is_aic_one_login', false);

        this.$store.dispatch('setCurrentUserId', response_data.user_id);
        this.$store.dispatch('setCurrentLeadId', response_data.lead_id);
        this.$store.dispatch('setCurrentRole', response_data.role_type);
        this.$store.dispatch('setCurrentLeadName', response_data.full_name);

        this.$router.push('/one_time_pin');
      } catch (error) {
        this.show_error(
          error?.response?.data?.message ||
          'Invalid username or password.'
        );
      } finally {
        this.verification_running = false;
      }
    },

    toggle_password_visibility() {
      this.show_password = !this.show_password;
    }
  }
};
